<template>
<div class="chapter">
<div class="inner_page">
<div class="cover" id="cover"><a href="#/text/9780063075771_Contents#rcover"><img alt="image" src="images/9780063075771_Cover.jpg"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063075771_Cover.vue?1ced2a4e